// extracted by mini-css-extract-plugin
export var cardIcon = "_95-4";
export var checkboxCard = "_95-0";
export var checkboxCardSelected = "_95-1";
export var disabled = "_95-2";
export var outerBorder = "_95-3";
export var spacerMedium = "_95-7";
export var spacerSmall = "_95-6";
export var spacerXsmall = "_95-5";